export type ToggleScheduleFeedback = {
  type: 'TOGGLE_SCHEDULE_FEEDBACK'
  payload: { listId: string }
}
export const TOGGLE_SCHEDULE_FEEDBACK = 'TOGGLE_SCHEDULE_FEEDBACK'
export const toggleScheduleFeedback = (listId: string): ToggleScheduleFeedback => {
  return { type: TOGGLE_SCHEDULE_FEEDBACK, payload: { listId } }
}

export type ToggleScheduleEvents = { type: 'TOGGLE_SCHEDULE_EVENTS' }
export const TOGGLE_SCHEDULE_EVENTS = 'TOGGLE_SCHEDULE_EVENTS'
export const toggleScheduleEvents = (): ToggleScheduleEvents => ({
  type: TOGGLE_SCHEDULE_EVENTS,
})

export type SchedulePageAction = ToggleScheduleEvents | ToggleScheduleFeedback
